import { render, staticRenderFns } from "./StudyPermissions.vue?vue&type=template&id=1c05903e"
import script from "./StudyPermissions.vue?vue&type=script&lang=js"
export * from "./StudyPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports